module.exports = __webpack_public_path__ + "static/Instrukcja_montazu_wspornikow_uniwersalnych_na_rabek_stojacy-f6d8c0785bdfab748f7508a87cf72bc0.pdf";